export class MyClientsCriteria {
    ApplicationStartDate: string = ""
    ApplicationEndDate: string = ""
    OrgList: string = ""
    OrgID: number = 0
    OrgName: string = ""
    UserType: string = ""
    AgentID: string = ""
    LoginProfileID: string = ""
    ReportCategory: string = "ALL"
    Plans: string = "ALL"
    PageSize: number = 50
    PageNumber: number = 1
    SortFields: string = ""
    FilterCriteria: string = ""
    EnrollmentRecId: number = 0
    SourceId: string = ""
    State: string = ""
    Carrier: string = ""
    CUID: string = ""
    InsuranceCompany: string = ""
    GroupName: string = ""
    GroupNumber: string = ""
    StateAbbr: string = ""
    ReportType: string = ""
    IsClearReport: boolean = false;
}